import React, { useState } from "react";

// Material UI Components
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";

// Components
import LatestLeadsHeader from "./LatestLeadsHeader";
import LatestLeadsBody from "./LatestLeadsBody";
import Paginate from "../../../../Utilities/Paginate";

// This component will hold the latest leads data
const LatestLeadsTable = ({ leads }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("leadDate");

  const handleChangePage = (event, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const descendingComparator = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  };

  const getComparator = (order, orderBy) => {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  };

  const handleRequestSort = (e, id) => {
    const isAsc = orderBy === id && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(id);
  };

  const stableSort = (array, comparator) => {
    return array
      .map((el, index) => [el, index])
      .sort((a, b) => {
        const lead = comparator(a[0], b[0]);
        if (lead !== 0) return lead;
        return a[1] - b[1];
      })
      .map((el) => el[0]);
  };

  const createData = (
    customerId,
    firstname,
    lastname,
    campaignName,
    emailAddress,
    ip,
    leadDate,
    visitorHash
  ) => {
    return {
      customerId,
      firstname,
      lastname,
      campaignName,
      emailAddress,
      ip,
      leadDate,
      visitorHash,
    };
  };
  const Leads = leads.map(
    ({
      leadId,
      firstname,
      lastname,
      campaignName,
      emailAddress,
      ip,
      leadDate,
      visitorHash,
    }) =>
      createData(
        leadId,
        firstname,
        lastname,
        campaignName,
        emailAddress,
        ip,
        leadDate,
        visitorHash
      )
  );
  return (
    <div className="root">
      <TableContainer>
        <Table className="table" size={"small"}>
          <LatestLeadsHeader
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
          />
          <LatestLeadsBody
            leads={Leads}
            page={page}
            rowsPerPage={rowsPerPage}
            stableSort={stableSort}
            getComparator={getComparator}
            order={order}
            orderBy={orderBy}
          />
        </Table>
      </TableContainer>
      <Paginate totalRowCount={leads.length} page={page} rowsPerPage={rowsPerPage} handleChange={handleChangePage} handleChangeRowsPerPage={handleChangeRowsPerPage} />
    </div>
  );
};

export default LatestLeadsTable;
